import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "pwa-payroll" }
const _hoisted_2 = { class: "payroll-header" }
const _hoisted_3 = { class: "header-row" }
const _hoisted_4 = { class: "tabs" }
const _hoisted_5 = { class: "summary-bar" }
const _hoisted_6 = { class: "summary-item" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "payroll-list" }
const _hoisted_10 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_11 = { class: "empty-sub" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "emp-info" }
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "job" }
const _hoisted_16 = { class: "pay-amount" }
const _hoisted_17 = { class: "sheet-header" }
const _hoisted_18 = {
  key: 0,
  class: "sheet-body"
}
const _hoisted_19 = { class: "detail-top" }
const _hoisted_20 = { class: "info" }
const _hoisted_21 = { class: "name" }
const _hoisted_22 = { class: "job" }
const _hoisted_23 = {
  key: 0,
  class: "detail-group"
}
const _hoisted_24 = { class: "row" }
const _hoisted_25 = {
  key: 0,
  class: "row"
}
const _hoisted_26 = { class: "detail-group" }
const _hoisted_27 = {
  key: 0,
  class: "row"
}
const _hoisted_28 = {
  key: 1,
  class: "row"
}
const _hoisted_29 = {
  key: 2,
  class: "row"
}
const _hoisted_30 = {
  key: 3,
  class: "row"
}
const _hoisted_31 = {
  key: 4,
  class: "row"
}
const _hoisted_32 = {
  key: 5,
  class: "row"
}
const _hoisted_33 = {
  key: 6,
  class: "row"
}
const _hoisted_34 = {
  key: 7,
  class: "row"
}
const _hoisted_35 = {
  key: 8,
  class: "row"
}
const _hoisted_36 = {
  key: 9,
  class: "row"
}
const _hoisted_37 = { class: "row total" }
const _hoisted_38 = { class: "blue" }
const _hoisted_39 = { class: "detail-group" }
const _hoisted_40 = {
  key: 0,
  class: "row"
}
const _hoisted_41 = { class: "red" }
const _hoisted_42 = {
  key: 1,
  class: "row"
}
const _hoisted_43 = { class: "red" }
const _hoisted_44 = {
  key: 2,
  class: "row"
}
const _hoisted_45 = { class: "red" }
const _hoisted_46 = {
  key: 3,
  class: "row"
}
const _hoisted_47 = { class: "red" }
const _hoisted_48 = {
  key: 4,
  class: "row"
}
const _hoisted_49 = { class: "red" }
const _hoisted_50 = {
  key: 5,
  class: "row"
}
const _hoisted_51 = { class: "red" }
const _hoisted_52 = { class: "row total" }
const _hoisted_53 = { class: "red" }
const _hoisted_54 = { class: "net-pay-card" }
const _hoisted_55 = { class: "amount" }
const _hoisted_56 = { class: "sheet-header" }
const _hoisted_57 = { class: "sheet-body" }
const _hoisted_58 = { class: "year-selector" }
const _hoisted_59 = { class: "year-text" }
const _hoisted_60 = { class: "month-grid" }
const _hoisted_61 = ["disabled", "onClick"]

import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import axios from 'axios';
import LodingComponent from '@/components/loading/LodingComponent.vue';

const STORAGE_KEY = 'pwa_payroll_yearMonth';

// 저장된 연월 또는 지난달 기본값

export default /*@__PURE__*/_defineComponent({
  __name: 'PwaPayroll',
  setup(__props) {

const store = useStore();
const route = useRoute();
const user = computed(() => store.state.user);

const isLoading = ref(false);
const activeTab = ref<'yobo' | 'staff'>('yobo');
const showDetailSheet = ref(false);
const showYearMonthSheet = ref(false);
const selectedPayroll = ref<any>(null);

// localStorage 키
const getSavedYearMonth = () => {
  const saved = localStorage.getItem(STORAGE_KEY);
  if (saved && saved.length === 6) {
    return {
      year: parseInt(saved.substring(0, 4)),
      month: parseInt(saved.substring(4, 6))
    };
  }
  // 기본값: 지난달
  const now = new Date();
  const lastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  return { year: lastMonth.getFullYear(), month: lastMonth.getMonth() + 1 };
};

const yearMonth = ref(getSavedYearMonth());

// 연월 변경 시 localStorage에 저장
const saveYearMonth = () => {
  const ym = `${yearMonth.value.year}${String(yearMonth.value.month).padStart(2, '0')}`;
  localStorage.setItem(STORAGE_KEY, ym);
};
const selectedYearMonth = computed(() => 
  `${yearMonth.value.year}${String(yearMonth.value.month).padStart(2, '0')}`
);

const payrollData = ref<any[]>([]);
const isMagamClosed = ref(false);

// 탭에 따라 필터링
const currentList = computed(() => {
  if (activeTab.value === 'yobo') {
    return payrollData.value.filter(item => item.emp_job === '요양보호사');
  } else {
    return payrollData.value.filter(item => 
      item.emp_job === '센터장' || item.emp_job === '사회복지사'
    );
  }
});

const summaryData = computed(() => {
  const list = currentList.value;
  return {
    totalCount: list.length,
    totalNet: list.reduce((sum, item) => sum + (parseInt(item.ewi_net_pay) || 0), 0)
  };
});

// 급여 데이터 조회
const fetchPayrollData = async () => {
  if (!user.value?.m_sisul_code) {
    console.warn('사용자 정보가 없습니다.');
    return;
  }
  
  try {
    isLoading.value = true;
    const ym = selectedYearMonth.value;
    const year = ym.substring(0, 4);
    const sisulCode = user.value.m_sisul_code;

    // 마감 상태 확인
    try {
      const magamResponse = await axios.get(
        `/api/calc/wage-magam-yearly/${sisulCode}/${year}`,
        { withCredentials: true }
      );
      if (magamResponse.data.success) {
        const magamData = magamResponse.data.data || [];
        isMagamClosed.value = magamData.some(
          (m: any) => m.wm_ym === ym && m.wm_job_type === '전체합계' && m.wm_isuse === 'y'
        );
      }
    } catch (e) {
      console.error('마감 상태 조회 오류:', e);
    }

    // 급여 데이터 조회 (hh_emp_sabok_work_info 테이블에서)
    const response = await axios.get('/api/calc/yobo-payroll', {
      params: {
        sisulCode: sisulCode,
        yearMonth: ym
      },
      withCredentials: true
    });

    if (response.data.success) {
      payrollData.value = response.data.data || [];
    } else {
      payrollData.value = [];
    }
  } catch (error) {
    console.error('급여 데이터 조회 오류:', error);
    payrollData.value = [];
    store.commit('showSnackbar', {
      text: '급여 데이터를 불러오지 못했습니다.',
      color: 'error'
    });
  } finally {
    isLoading.value = false;
  }
};

// 유틸리티
const formatYearMonth = (ym: string) => {
  if (!ym || ym.length !== 6) return '';
  return `${ym.substring(0, 4)}년 ${parseInt(ym.substring(4, 6))}월`;
};

const formatCurrency = (value: number) => {
  if (!value) return '0원';
  return new Intl.NumberFormat('ko-KR').format(value) + '원';
};

const getJobColor = (job?: string) => {
  if (job === '요양보호사') return 'yobo';
  if (job === '사회복지사') return 'sabok';
  if (job === '센터장') return 'sisul';
  return 'default';
};

const isFutureMonth = (month: number) => {
  const now = new Date();
  if (yearMonth.value.year > now.getFullYear()) return true;
  if (yearMonth.value.year === now.getFullYear() && month > now.getMonth() + 1) return true;
  return false;
};

const selectMonth = (month: number) => {
  yearMonth.value.month = month;
  saveYearMonth(); // localStorage에 저장
  showYearMonthSheet.value = false;
  fetchPayrollData();
};

const openPayrollDetail = (item: any) => {
  selectedPayroll.value = item;
  showDetailSheet.value = true;
};

// URL 쿼리에서 ym 가져오기 또는 localStorage에서 복원
onMounted(() => {
  const ymParam = route.query.ym as string;
  if (ymParam && ymParam.length === 6) {
    yearMonth.value = {
      year: parseInt(ymParam.substring(0, 4)),
      month: parseInt(ymParam.substring(4, 6))
    };
    saveYearMonth(); // URL 파라미터도 저장
  }
  // getSavedYearMonth()에서 이미 localStorage 값을 불러왔으므로 바로 조회
  fetchPayrollData();
});

// 연도 변경 시 localStorage 저장 (월은 selectMonth에서 저장)
watch(() => yearMonth.value.year, () => {
  saveYearMonth();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "page-title" }, "급여", -1)),
        _createElementVNode("button", {
          class: "ym-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showYearMonthSheet.value = true))
        }, [
          _createTextVNode(_toDisplayString(formatYearMonth(selectedYearMonth.value)) + " ", 1),
          _createVNode(_component_v_icon, { size: "16" }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
              _createTextVNode("mdi-chevron-down", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass({ active: activeTab.value === 'yobo' }),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'yobo'))
        }, "요양보호사", 2),
        _createElementVNode("button", {
          class: _normalizeClass({ active: activeTab.value === 'staff' }),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 'staff'))
        }, "센터장·사회복지사", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(currentList.value.length) + "명", 1),
        _createElementVNode("span", _hoisted_8, _toDisplayString(formatCurrency(summaryData.value.totalNet)), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["magam-chip", { closed: isMagamClosed.value }])
      }, _toDisplayString(isMagamClosed.value ? '마감완료' : '진행중'), 3)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(8, (n) => {
            return _createElementVNode("div", {
              key: n,
              class: "payroll-item skeleton"
            }, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("div", { class: "skeleton-avatar" }, null, -1),
              _createElementVNode("div", { class: "skeleton-text" }, null, -1),
              _createElementVNode("div", { class: "skeleton-amount" }, null, -1)
            ]))])
          }), 64))
        : (currentList.value.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_v_icon, {
                size: "48",
                color: "#d1d5db"
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("mdi-currency-krw", -1)
                ]))]),
                _: 1
              }),
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "empty-title" }, "급여 데이터가 없습니다", -1)),
              _createElementVNode("span", _hoisted_11, _toDisplayString(formatYearMonth(selectedYearMonth.value)) + " 급여 정보가 아직 등록되지 않았습니다", 1)
            ]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(currentList.value, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.emp_code,
                class: "payroll-item",
                onClick: ($event: any) => (openPayrollDetail(item))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["emp-avatar", getJobColor(item.emp_job)])
                }, _toDisplayString(item.emp_name?.charAt(0)), 3),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(item.emp_name), 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(item.emp_job || (activeTab.value === 'yobo' ? '요양보호사' : '')), 1)
                ]),
                _createElementVNode("div", _hoisted_16, _toDisplayString(formatCurrency(item.ewi_net_pay || 0)), 1)
              ], 8, _hoisted_12))
            }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["sheet-overlay", { open: showDetailSheet.value }]),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (showDetailSheet.value = false))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["sheet detail-sheet", { open: showDetailSheet.value }])
    }, [
      _cache[40] || (_cache[40] = _createElementVNode("div", { class: "sheet-handle" }, null, -1)),
      _createElementVNode("div", _hoisted_17, [
        _cache[15] || (_cache[15] = _createElementVNode("span", null, "급여 상세", -1)),
        _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (showDetailSheet.value = false))
        }, [
          _createVNode(_component_v_icon, { size: "20" }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
              _createTextVNode("mdi-close", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      (selectedPayroll.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: _normalizeClass(["avatar", getJobColor(selectedPayroll.value.emp_job)])
              }, _toDisplayString(selectedPayroll.value.emp_name?.charAt(0)), 3),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(selectedPayroll.value.emp_name), 1),
                _createElementVNode("span", _hoisted_22, _toDisplayString(selectedPayroll.value.emp_job || '요양보호사'), 1)
              ])
            ]),
            (selectedPayroll.value.ewi_suga_hours)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "group-title" }, "근무 정보", -1)),
                  _createElementVNode("div", _hoisted_24, [
                    _cache[16] || (_cache[16] = _createElementVNode("span", null, "수가시간", -1)),
                    _createElementVNode("span", null, _toDisplayString(selectedPayroll.value.ewi_suga_hours) + "시간", 1)
                  ]),
                  (selectedPayroll.value.ewi_service_days)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", null, "근무일수", -1)),
                        _createElementVNode("span", null, _toDisplayString(selectedPayroll.value.ewi_service_days) + "일", 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_26, [
              _cache[30] || (_cache[30] = _createElementVNode("div", { class: "group-title" }, "지급 내역", -1)),
              (selectedPayroll.value.ewi_basic_pay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _cache[19] || (_cache[19] = _createElementVNode("span", null, "기본급", -1)),
                    _createElementVNode("span", null, _toDisplayString(formatCurrency(selectedPayroll.value.ewi_basic_pay)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_weekly_pay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _cache[20] || (_cache[20] = _createElementVNode("span", null, "주휴수당", -1)),
                    _createElementVNode("span", null, _toDisplayString(formatCurrency(selectedPayroll.value.ewi_weekly_pay)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_annual_pay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "연차수당", -1)),
                    _createElementVNode("span", null, _toDisplayString(formatCurrency(selectedPayroll.value.ewi_annual_pay)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_meal_pay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _cache[22] || (_cache[22] = _createElementVNode("span", null, "식대", -1)),
                    _createElementVNode("span", null, _toDisplayString(formatCurrency(selectedPayroll.value.ewi_meal_pay)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_holiday_pay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", null, "휴일수당", -1)),
                    _createElementVNode("span", null, _toDisplayString(formatCurrency(selectedPayroll.value.ewi_holiday_pay)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_overtime_pay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _cache[24] || (_cache[24] = _createElementVNode("span", null, "연장수당", -1)),
                    _createElementVNode("span", null, _toDisplayString(formatCurrency(selectedPayroll.value.ewi_overtime_pay)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_night_pay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                    _cache[25] || (_cache[25] = _createElementVNode("span", null, "야간수당", -1)),
                    _createElementVNode("span", null, _toDisplayString(formatCurrency(selectedPayroll.value.ewi_night_pay)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_long_service_pay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _cache[26] || (_cache[26] = _createElementVNode("span", null, "장기근속수당", -1)),
                    _createElementVNode("span", null, _toDisplayString(formatCurrency(selectedPayroll.value.ewi_long_service_pay)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_bosu_edu_pay)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                    _cache[27] || (_cache[27] = _createElementVNode("span", null, "보수교육비", -1)),
                    _createElementVNode("span", null, _toDisplayString(formatCurrency(selectedPayroll.value.ewi_bosu_edu_pay)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_severe_care_addition)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _cache[28] || (_cache[28] = _createElementVNode("span", null, "중증가산", -1)),
                    _createElementVNode("span", null, _toDisplayString(formatCurrency(selectedPayroll.value.ewi_severe_care_addition)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_37, [
                _cache[29] || (_cache[29] = _createElementVNode("span", null, "지급 합계", -1)),
                _createElementVNode("span", _hoisted_38, _toDisplayString(formatCurrency(selectedPayroll.value.ewi_total_pay || 0)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "group-title" }, "공제 내역", -1)),
              (selectedPayroll.value.ewi_emp_yeon)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _cache[31] || (_cache[31] = _createElementVNode("span", null, "국민연금", -1)),
                    _createElementVNode("span", _hoisted_41, "-" + _toDisplayString(formatCurrency(selectedPayroll.value.ewi_emp_yeon)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_emp_gun)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _cache[32] || (_cache[32] = _createElementVNode("span", null, "건강보험", -1)),
                    _createElementVNode("span", _hoisted_43, "-" + _toDisplayString(formatCurrency(selectedPayroll.value.ewi_emp_gun)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_emp_jang)
                ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                    _cache[33] || (_cache[33] = _createElementVNode("span", null, "장기요양보험", -1)),
                    _createElementVNode("span", _hoisted_45, "-" + _toDisplayString(formatCurrency(selectedPayroll.value.ewi_emp_jang)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_emp_go)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _cache[34] || (_cache[34] = _createElementVNode("span", null, "고용보험", -1)),
                    _createElementVNode("span", _hoisted_47, "-" + _toDisplayString(formatCurrency(selectedPayroll.value.ewi_emp_go)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_emp_so)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    _cache[35] || (_cache[35] = _createElementVNode("span", null, "소득세", -1)),
                    _createElementVNode("span", _hoisted_49, "-" + _toDisplayString(formatCurrency(selectedPayroll.value.ewi_emp_so)), 1)
                  ]))
                : _createCommentVNode("", true),
              (selectedPayroll.value.ewi_emp_ji)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                    _cache[36] || (_cache[36] = _createElementVNode("span", null, "지방소득세", -1)),
                    _createElementVNode("span", _hoisted_51, "-" + _toDisplayString(formatCurrency(selectedPayroll.value.ewi_emp_ji)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_52, [
                _cache[37] || (_cache[37] = _createElementVNode("span", null, "공제 합계", -1)),
                _createElementVNode("span", _hoisted_53, "-" + _toDisplayString(formatCurrency(selectedPayroll.value.ewi_emp_total_deduction || 0)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              _cache[39] || (_cache[39] = _createElementVNode("span", { class: "label" }, "실지급액", -1)),
              _createElementVNode("span", _hoisted_55, _toDisplayString(formatCurrency(selectedPayroll.value.ewi_net_pay || 0)), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["sheet-overlay", { open: showYearMonthSheet.value }]),
      onClick: _cache[5] || (_cache[5] = ($event: any) => (showYearMonthSheet.value = false))
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass(["sheet ym-sheet", { open: showYearMonthSheet.value }])
    }, [
      _cache[45] || (_cache[45] = _createElementVNode("div", { class: "sheet-handle" }, null, -1)),
      _createElementVNode("div", _hoisted_56, [
        _cache[42] || (_cache[42] = _createElementVNode("span", null, "연월 선택", -1)),
        _createElementVNode("button", {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (showYearMonthSheet.value = false))
        }, [
          _createVNode(_component_v_icon, { size: "20" }, {
            default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
              _createTextVNode("mdi-close", -1)
            ]))]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_57, [
        _createElementVNode("div", _hoisted_58, [
          _createElementVNode("button", {
            class: "arrow-btn",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (yearMonth.value.year--))
          }, [
            _createVNode(_component_v_icon, { size: "24" }, {
              default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                _createTextVNode("mdi-chevron-left", -1)
              ]))]),
              _: 1
            })
          ]),
          _createElementVNode("span", _hoisted_59, _toDisplayString(yearMonth.value.year) + "년", 1),
          _createElementVNode("button", {
            class: "arrow-btn",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (yearMonth.value.year++))
          }, [
            _createVNode(_component_v_icon, { size: "24" }, {
              default: _withCtx(() => [...(_cache[44] || (_cache[44] = [
                _createTextVNode("mdi-chevron-right", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(12, (m) => {
            return _createElementVNode("button", {
              key: m,
              class: _normalizeClass(["month-btn", { active: yearMonth.value.month === m, disabled: isFutureMonth(m) }]),
              disabled: isFutureMonth(m),
              onClick: ($event: any) => (selectMonth(m))
            }, _toDisplayString(m) + "월 ", 11, _hoisted_61)
          }), 64))
        ])
      ])
    ], 2),
    _createVNode(LodingComponent, {
      "is-visible": isLoading.value,
      text: "급여 정보를 불러오는 중..."
    }, null, 8, ["is-visible"])
  ]))
}
}

})